import {Stack,
  Dialog,
  DialogContent,
  DialogContentText,
  Typography,
  Alert,
  Button
} from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Topbar from "./Topbar";
import Footer from "./Footer";
import {UPDATE_CONSENT_QUERY} from "../../graphql/mutations_landing_page_consent";
import {apiRequest} from "../../services/utils/HttpUtils";
import {useMutation, useQueryClient, useQuery} from "@tanstack/react-query";
import {useMsal, useIsAuthenticated} from "@azure/msal-react";
import {TermsOfUsePopup} from "./termAndCondition";
import {getUserInfo} from "../../graphql/queries_user_info";

export default function Main(props: { children }) {
  const client = useQueryClient();
  const {instance, accounts} = useMsal();
	const {children} = props;
  const isAuthenticated = useIsAuthenticated();
  const [consent, setConsent] = React.useState(false);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const {mutate: updateConsent} = useMutation(["updateConsent"], {
    mutationFn: (variables: any) => {
      return apiRequest(
        {
          query: UPDATE_CONSENT_QUERY,
          variables: variables,
          instance: instance,
          accounts: accounts
        })
    },
    onSuccess: () => {
      client.invalidateQueries(["getUserInfo"]);
    }
  });

  const { data: userInfo } = getUserInfo();


  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setAlertOpen(false);
  };

  const action = (
    <React.Fragment>
      <Button color="secondary" size="small" onClick={handleClose}>
        UNDO
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  return (
		<Box
			sx={{ height: "100%", width: "100%"}}
			display='flex'>
			<Stack sx={{ width: "100%"}}>
				<Box sx={{ height: "10vh"}}>
					<Topbar/>
				</Box>
				<Box sx={{ minHeight: "79vh", zIndex: "400", p: ".5%", pr: "6%"}}
				>
					{children}
				</Box>
				<Box sx={{ height: "10vh"}}>
					<Footer/>
				</Box>
			</Stack>
      <Dialog
        // @ts-ignore
        open={!consent && isAuthenticated}
        fullWidth={true}
        maxWidth="md"
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            maxWidth: "80%",
            height: "80vh",
            maxHeight: "80vh",
          },
        }}
      >
        <DialogContent sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
          <DialogContentText component="div" sx={{ textAlign: "center" }}>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%" }}>
              <TermsOfUsePopup />
            </Box>
          </DialogContentText>
          <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "center", mt: 2 }}> {/* Buttons at the bottom, centered */}
            <Button
              variant="contained"
              onClick={() => {
                setConsent(true);
                updateConsent({ inConsent: true });
              }}
              // @ts-ignore
              disabled={!userInfo?.executeGetUser[0]?.Jurisdiction}
            >Consent</Button>
            <Button
              onClick={() => {
                setConsent(false);
                updateConsent({ inConsent: false });
                setAlertOpen(true);
              }}
            >No</Button>
            <Snackbar
              open={alertOpen}
              autoHideDuration={3000}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              onClose={handleClose}
              action={action}
            >
              <Alert
                onClose={handleClose}
                severity="warning"
                variant="filled"
                sx={{ width: '100%' }}
              >
                Please consent to the TOU to proceed
              </Alert>
            </Snackbar>
          </Box>
        </DialogContent>
      </Dialog>
		</Box>
	);
}
